export default __webpack_public_path__ + "images/models/17ee1fd70fc827c334ef5db636ccc22d.usdz";